import axios from 'axios';
import { API_ROOT, logApiError } from '@/store/api';
import { MAILOSAUR_DOMAIN, PRODUCTION } from './constants';

// Check if message contains test user patterns (e2e tests)
const isTestUser = message => {
    if (!MAILOSAUR_DOMAIN) return false;
    return message?.includes(`@${MAILOSAUR_DOMAIN}`);
};

export default {
    namespaced: true,
    actions: {
        async sendSlackNotification({ dispatch }, payload) {
            // Skip notifications for test users (e2e tests)
            if (isTestUser(payload.message)) {
                console.log(`Skipping Slack notification for test user to "${payload.channel}": ${payload.message}`);
                return true;
            } else if (!PRODUCTION) {
                console.log(`Slack notification to "${payload.channel}": ${payload.message}`);
                return true;
            }

            try {
                const { data } = await axios.post(`${API_ROOT}/notifier/slack/`, payload);

                return { data };
            } catch (e) {
                logApiError(e, dispatch);
                return false;
            }
        },
        // Advisor bulk client-data upload: posts the details + file as multipart to the
        // backend, which stores the file and notifies the client-administration Slack channel.
        // Uses axiosConfig for the HttpOnly auth cookie; Content-Type is intentionally left
        // unset so the browser adds the multipart boundary. Unlike sendSlackNotification this
        // always hits the backend (the backend handles non-prod dry-run itself).
        async submitClientDataUpload({ dispatch, rootGetters }, { name, email, description, file }) {
            try {
                const form = new FormData();
                form.append('name', name || '');
                form.append('email', email || '');
                form.append('description', description || '');
                form.append('file', file);

                const { data } = await axios.post(
                    `${API_ROOT}/advisor/client-data-upload/`,
                    form,
                    rootGetters.axiosConfig,
                );

                return data || true;
            } catch (e) {
                logApiError(e, dispatch);
                return false;
            }
        },
    },
};
